<template>
  <div class="profile">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="javascript:void(0)"><img :src="user.image_path" class="rounded-circle" /></a>
                </div>
              </div>
            </div>
            <div class="pt-8 pt-md-4 pb-0 pb-md-4"></div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="card-profile-stats d-flex justify-content-center mt-md-5"></div>
                </div>
              </div>
              <div class="text-center">
                <h3>{{ user.full_name }}</h3>
                <div class="h5 font-weight-300 text-uppercase">
                  {{ user.type }}
                </div>
              </div>
              <hr />
              <div class="d-flex justify-content-center">
                <b-form data-vv-scope="foto-profile-form">
                  <b-form-group id="image_path">
                    <b-form-file
                      ref="image_path"
                      name="image_path"
                      data-vv-as="File"
                      v-model="foto_profile"
                      :state="Boolean(foto_profile)"
                      type="file"
                      placeholder="Pilih file disini. . ."
                      drop-placeholder="Drop file here..."
                      v-validate="'required'"
                      accept="image/*"
                    >
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('foto-profile-form.image_path') }">{{ errors.first("foto-profile-form.image_path") }}</span>
                  </b-form-group>
                  <div class="d-flex justify-content-center">
                    <square-loader :loading="showFotoUploadLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                    <b-button v-if="!showFotoUploadLoader" variant="primary" size="md" @click="saveFotoProfile">Ganti Foto Profil</b-button>
                  </div>
                </b-form>
              </div>
            </div>
          </div>

          <!-- start ttd-->
          <div class="card card-profile shadow">
            <div class="card-body pt-0 pt-md-4">
              <div class="text-center">
                <h3>Tanda Tangan</h3>
              </div>
              <div class="text-center">
                <a href="javascript:void(0)"><img :src="user.ttd" /></a>
              </div>
              <hr />
              <div class="d-flex justify-content-center">
                <b-form data-vv-scope="ttd-form">
                  <b-form-group id="ttd">
                    <b-form-file ref="ttd" name="ttd" data-vv-as="File" v-model="ttd" :state="Boolean(ttd)" type="file" placeholder="Pilih file disini. . ." drop-placeholder="Drop file here..." v-validate="'required'" accept="image/*">
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('ttd-form.ttd') }">{{ errors.first("ttd-form.ttd") }}</span>
                  </b-form-group>
                  <div class="d-flex justify-content-center">
                    <square-loader :loading="showFotoUploadLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                    <b-button v-if="!showFotoUploadLoader" variant="primary" size="md" @click="saveTtd">Ganti Tanda Tangan</b-button>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
          <!-- end ttd -->
        </div>

        <div class="col-xl-8 order-xl-1">
          <b-card no-body>
            <b-tabs card fill>
              <b-tab title="Profil" active :title-item-class="'tab-title'">
                <b-card-text>
                  <b-card no-body>
                    <b-tabs card fill>
                      <b-tab title="Profil Saya" active :title-item-class="'tab-title'">
                        <b-card-text>
                          <b-form data-vv-scope="profil-form">
                            <div class="row">
                              <b-form-group id="nama-lengkap" label="Nama Lengkap">
                                <b-form-input
                                  id="input-full-name"
                                  class="form-profil"
                                  name="full_name"
                                  data-vv-as="Nama lengkap"
                                  v-model="profil_form.full_name"
                                  type="text"
                                  placeholder="Nama Lengkap"
                                  v-validate="'required'"
                                  trim
                                  autocomplete="off"
                                ></b-form-input>
                                <span :class="{ 'error-validation': errors.first('profil-form.full_name') }">{{ errors.first("profil-form.full_name") }}</span>
                              </b-form-group>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="nik_siswa" label="NIK Siswa">
                                  <b-form-input
                                    id="input-nik-siswa"
                                    class="form-profil"
                                    name="nik_siswa"
                                    data-vv-as="NIK Siswa"
                                    v-model="profil_form.nik_siswa"
                                    type="text"
                                    placeholder="NIK Siswa"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.nik_siswa') }">{{ errors.first("profil-form.nik_siswa") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="pekerjaan_siswa" label="Pekerjaan Siswa">
                                  <b-form-input
                                    id="input-pekerjaan-siswa"
                                    class="form-profil"
                                    name="pekerjaan_siswa"
                                    data-vv-as="Pekerjaan Siswa"
                                    v-model="profil_form.pekerjaan_siswa"
                                    type="text"
                                    placeholder="Pekerjaan Siswa"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.pekerjaan_siswa') }">{{ errors.first("profil-form.pekerjaan_siswa") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="gender" label="Jenis Kelamin">
                                  <b-form-select v-model="profil_form.gender" name="gender" data-vv-as="Jenis kelamin" :options="gender" v-validate="'required'"> </b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-form.gender') }">{{ errors.first("profil-form.gender") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="email" label="Email" description="Kita tidak akan menyebarkan surel anda kepada siapapun.">
                                  <b-form-input
                                    id="input-email"
                                    class="form-profil"
                                    name="email"
                                    data-vv-as="Email"
                                    v-model="profil_form.email"
                                    type="text"
                                    placeholder="Email"
                                    v-validate="'required|email'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.email') }">{{ errors.first("profil-form.email") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <!-- <div class="row">
                                                            <div class="col-xl-6">
                                                                <b-form-group
                                                                    id="province"
                                                                    label="Provinsi"
                                                                >
                                                                    <b-form-select
                                                                        v-model="profil_form.province"
                                                                        name="province"
                                                                        data-vv-as="Provinsi"
                                                                        :options="provinces"
                                                                        v-validate="'required'"
                                                                        value-field="code"
                                                                        text-field="name"
                                                                    >
                                                                        <b-form-select-option :value="null">Please select an option</b-form-select-option>
                                                                    </b-form-select>
                                                                    <span :class="{ 'error-validation': errors.first('profil-form.province') }">{{ errors.first('profil-form.province') }}</span>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-xl-6">
                                                                <b-form-group
                                                                    id="district"
                                                                    label="Kota/Kabupaten"
                                                                >
                                                                    <b-form-select
                                                                        v-model="profil_form.district"
                                                                        name="district"
                                                                        data-vv-as="Kota/Kabupaten"
                                                                        :options="districts"
                                                                        v-validate="'required'"
                                                                        value-field="code"
                                                                        text-field="name"
                                                                        :disabled="profil_form.province == null"
                                                                    >
                                                                        <b-form-select-option :value="null">Please select an option</b-form-select-option>
                                                                    </b-form-select>
                                                                    <span :class="{ 'error-validation': errors.first('profil-form.district') }">{{ errors.first('profil-form.district') }}</span>
                                                                </b-form-group>
                                                            </div>
                                                        </div> -->
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="place_of_birth" label="Tempat Lahir">
                                  <b-form-input
                                    id="input-place_of_birth"
                                    class="form-profil"
                                    name="place_of_birth"
                                    data-vv-as="Tempat Lahir"
                                    v-model="profil_form.place_of_birth"
                                    type="text"
                                    placeholder="Tempat Lahir"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.place_of_birth') }">{{ errors.first("profil-form.place_of_birth") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="date_of_birth" label="Tanggal Lahir (Format : tahun-bulan-hari)">
                                  <b-input-group class="mb-2">
                                    <b-form-input id="input-date_of_birth" v-model="profil_form.date_of_birth" type="text" placeholder="contoh: 2023-12-23" v-validate="'required'" autocomplete="off"></b-form-input>
                                    <b-input-group-append>
                                      <b-form-datepicker v-model="profil_form.date_of_birth" button-only right locale="en-US" name="date_of_birth" aria-controls="example-input"></b-form-datepicker>
                                    </b-input-group-append>
                                  </b-input-group>

                                  <!-- <b-form-datepicker
                                                                        id="input-date_of_birth"
                                                                        v-model="profil_form.date_of_birth"
                                                                        name="date_of_birth"
                                                                        data-vv-as="Tanggal Lahir"
                                                                        v-validate="'required'"
                                                                        class="mb-2"
                                                                    ></b-form-datepicker> -->
                                  <span :class="{ 'error-validation': errors.first('profil-form.date_of_birth') }">{{ errors.first("profil-form.date_of_birth") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="no_induk" label="Nomor Induk">
                                  <b-form-input id="input-no_induk" class="form-profil" name="no_induk" data-vv-as="Nomor Induk" v-model="profil_form.no_induk" type="text" placeholder="Nomor Induk" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.no_induk') }">{{ errors.first("profil-form.no_induk") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="nis_nas" label="Nomor Induk Siswa Nasional">
                                  <b-form-input
                                    id="input-nis_nas"
                                    class="form-profil"
                                    name="nis_nas"
                                    data-vv-as="Nomor Induk Siswa Nasional"
                                    v-model="profil_form.nis_nas"
                                    type="text"
                                    placeholder="Nomor Induk Siswa Nasional"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.nis_nas') }">{{ errors.first("profil-form.nis_nas") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="no_hp" label="Nomor HP">
                                  <b-form-input
                                    id="input-no_hp"
                                    class="form-profil"
                                    name="no_hp"
                                    data-vv-as="Nomor HP"
                                    v-model="profil_form.no_hp"
                                    type="text"
                                    placeholder="Nomor HP"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.no_hp') }">{{ errors.first("profil-form.no_hp") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="tinggal_bersama" label="Tinggal Bersama">
                                  <b-form-input
                                    id="input-tinggal_bersama"
                                    class="form-profil"
                                    name="tinggal_bersama"
                                    data-vv-as="Tinggal Bersama"
                                    v-model="profil_form.tinggal_bersama"
                                    type="text"
                                    placeholder="Tinggal Bersama"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.tinggal_bersama') }">{{ errors.first("profil-form.tinggal_bersama") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="agama" label="Agama">
                                  <b-form-select v-model="profil_form.agama" name="agama" data-vv-as="Agama" :options="agamaList" v-validate="'required'"> </b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-form.agama') }">{{ errors.first("profil-form.agama") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="anak_ke" label="Anak Ke">
                                  <b-form-select v-model="profil_form.anak_ke" name="anak_ke" data-vv-as="Anak Ke" :options="anakKeList" v-validate="'required'"> </b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-form.anak_ke') }">{{ errors.first("profil-form.anak_ke") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="saudara_kandung" label="Jumlah Saudara Kandung">
                                  <b-form-input
                                    id="input-saudara_kandung"
                                    class="form-profil"
                                    name="saudara_kandung"
                                    data-vv-as="Jumlah Saudara Kandung"
                                    v-model="profil_form.saudara_kandung"
                                    type="number"
                                    placeholder="Jumlah Saudara Kandung"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.saudara_kandung') }">{{ errors.first("profil-form.saudara_kandung") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="saudara_tiri" label="Jumlah Saudara Tiri">
                                  <b-form-input
                                    id="input-saudara_tiri"
                                    class="form-profil"
                                    name="saudara_tiri"
                                    data-vv-as="Jumlah Saudara Tiri"
                                    v-model="profil_form.saudara_tiri"
                                    type="number"
                                    placeholder="Jumlah Saudara Tiri"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.saudara_tiri') }">{{ errors.first("profil-form.saudara_tiri") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="status_keluarga" label="Status Keluarga">
                                  <b-form-input
                                    id="input-status_keluarga"
                                    class="form-profil"
                                    name="status_keluarga"
                                    data-vv-as="Status Keluarga"
                                    v-model="profil_form.status_keluarga"
                                    type="text"
                                    placeholder="Status Keluarga"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.status_keluarga') }">{{ errors.first("profil-form.status_keluarga") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="bahasa_sehari" label="Bahasa Sehari-hari">
                                  <b-form-input
                                    id="input-bahasa_sehari"
                                    class="form-profil"
                                    name="bahasa_sehari"
                                    data-vv-as="Bahasa Sehari-hari"
                                    v-model="profil_form.bahasa_sehari"
                                    type="text"
                                    placeholder="Bahasa Sehari-hari"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.bahasa_sehari') }">{{ errors.first("profil-form.bahasa_sehari") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="kewarganegaraan" label="Kewarganegaraan">
                                  <b-form-input
                                    id="input-kewarganegaraan"
                                    class="form-profil"
                                    name="kewarganegaraan"
                                    data-vv-as="Kewarganegaraan"
                                    v-model="profil_form.kewarganegaraan"
                                    type="text"
                                    placeholder="Kewarganegaraan"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-form.kewarganegaraan') }">{{ errors.first("profil-form.kewarganegaraan") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <!-- <div class="row">
                                                            <div class="col-xl-6">
                                                                <b-form-group
                                                                    id="address"
                                                                    label="Alamat Lengkap"
                                                                >
                                                                    <b-form-textarea
                                                                        id="input-address"
                                                                        class="form-profil"
                                                                        name="address"
                                                                        data-vv-as="Alamat Lengkap"
                                                                        v-model="profil_form.address"
                                                                        placeholder="Alamat Lengkap"
                                                                        v-validate="'required'"
                                                                        rows="3"
                                                                        max-rows="6"
                                                                        autocomplete="off"
                                                                    ></b-form-textarea>
                                                                    <span :class="{ 'error-validation': errors.first('profil-form.address') }">{{ errors.first('profil-form.address') }}</span>
                                                                </b-form-group>
                                                            </div>
                                                        </div> -->
                            <hr />
                            <div class="profil-footer d-flex justify-content-end">
                              <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                              <b-button v-if="!showLoader" variant="primary" size="md" @click="saveProfile">SIMPAN</b-button>
                            </div>
                          </b-form>
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Data Alamat" :title-item-class="'tab-title'">
                        <b-card-text>
                          <b-form data-vv-scope="profil-user-address">
                            <div class="row">
                              <div class="col-xl-8">
                                <b-form-group id="jalan" label="Jalan">
                                  <b-form-input id="input-jalan" class="form-user-address" name="jalan" v-model="user_address_form.jalan" type="text" placeholder="Jalan" v-validate="''" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.jalan') }">{{ errors.first("profil-user-address.jalan") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-2">
                                <b-form-group id="rt" label="RT">
                                  <b-form-input id="input-rt" class="form-user-address" name="rt" v-model="user_address_form.rt" type="text" placeholder="rt" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.rt') }">{{ errors.first("profil-user-address.rt") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-2">
                                <b-form-group id="rw" label="RW">
                                  <b-form-input id="input-rw" class="form-user-address" name="rw" v-model="user_address_form.rw" type="text" placeholder="rw" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.rw') }">{{ errors.first("profil-user-address.rw") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="dusun" label="Dusun">
                                  <b-form-input id="input-dusun" class="form-user-address" name="dusun" v-model="user_address_form.dusun" type="text" placeholder="dusun" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.dusun') }">{{ errors.first("profil-user-address.dusun") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="desa" label="Desa">
                                  <b-form-input id="input-desa" class="form-user-address" name="desa" v-model="user_address_form.desa" type="text" placeholder="desa" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.desa') }">{{ errors.first("profil-user-address.desa") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="kecamatan" label="Kecamatan">
                                  <b-form-input
                                    id="input-kecamatan"
                                    class="form-user-address"
                                    name="kecamatan"
                                    v-model="user_address_form.kecamatan"
                                    type="text"
                                    placeholder="kecamatan"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.kecamatan') }">{{ errors.first("profil-user-address.kecamatan") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="kabupaten" label="Kabupaten">
                                  <b-form-input
                                    id="input-kabupaten"
                                    class="form-user-address"
                                    name="kabupaten"
                                    v-model="user_address_form.kabupaten"
                                    type="text"
                                    placeholder="kabupaten"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.kabupaten') }">{{ errors.first("profil-user-address.kabupaten") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="provinsi" label="Provinsi">
                                  <b-form-input
                                    id="input-provinsi"
                                    class="form-user-address"
                                    name="provinsi"
                                    v-model="user_address_form.provinsi"
                                    type="text"
                                    placeholder="provinsi"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.provinsi') }">{{ errors.first("profil-user-address.provinsi") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="kode_pos" label="Kode Pos">
                                  <b-form-input
                                    id="input-kode_pos"
                                    class="form-user-address"
                                    name="kode_pos"
                                    v-model="user_address_form.kode_pos"
                                    type="number"
                                    placeholder="Kode Pos"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-address.kode_pos') }">{{ errors.first("profil-user-address.kode_pos") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <hr />
                            <div class="profil-footer d-flex justify-content-end">
                              <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                              <b-button v-if="!showLoader" variant="primary" size="md" @click="saveUserAddress">SIMPAN</b-button>
                            </div>
                          </b-form>
                        </b-card-text>
                      </b-tab>
                      <b-tab title="Data Orang Tua" :title-item-class="'tab-title'">
                        <b-card-text>
                          <b-form data-vv-scope="profil-user-ortu">
                            <fieldset>
                              <legend>Informasi Kartu Keluarga</legend>
                              <div class="row">
                                <div class="col-xl-6">
                                  <b-form-group id="no_kk" label="No. KK">
                                    <b-form-input
                                      id="input-no_kk"
                                      class="form-user-ortu"
                                      name="no_kk"
                                      v-model="user_ortu_form.no_kk"
                                      type="text"
                                      placeholder="No. KK"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.no_kk') }">{{ errors.first("profil-user-ortu.no_kk") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="nama_kk" label="Nama Kepala Keluarga">
                                    <b-form-input
                                      id="input-nama_kk"
                                      class="form-user-ortu"
                                      name="nama_kk"
                                      v-model="user_ortu_form.nama_kk"
                                      type="text"
                                      placeholder="Nama Kepala Keluarga"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.nama_kk') }">{{ errors.first("profil-user-ortu.nama_kk") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                            </fieldset>
                            <hr />
                            <fieldset>
                              <legend>Ayah</legend>
                              <div class="row">
                                <div class="col-xl-6">
                                  <b-form-group id="nik_ayah" label="NIK">
                                    <b-form-input
                                      id="input-nik_ayah"
                                      class="form-user-ortu"
                                      name="nik_ayah"
                                      v-model="user_ortu_form.nik_ayah"
                                      type="text"
                                      placeholder="NIK"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.nik_ayah') }">{{ errors.first("profil-user-ortu.nik_ayah") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="parent_name" label="Nama">
                                    <b-form-input
                                      id="input-parent_name"
                                      class="form-user-ortu"
                                      name="parent_name"
                                      v-model="user_ortu_form.parent_name"
                                      type="text"
                                      placeholder="Nama"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.parent_name') }">{{ errors.first("profil-user-ortu.parent_name") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-12">
                                  <b-form-group id="ayah_alamat" label="Alamat">
                                    <b-form-input
                                      id="input-ayah_alamat"
                                      class="form-user-ortu"
                                      name="ayah_alamat"
                                      v-model="user_ortu_form.ayah_alamat"
                                      type="text"
                                      placeholder="Alamat"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ayah_alamat') }">{{ errors.first("profil-user-ortu.ayah_alamat") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-3">
                                  <b-form-group id="ayah_pendidikan" label="Pendidikan">
                                    <b-form-input
                                      id="input-ayah_pendidikan"
                                      class="form-user-ortu"
                                      name="ayah_pendidikan"
                                      v-model="user_ortu_form.ayah_pendidikan"
                                      type="text"
                                      placeholder="Pendidikan"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ayah_pendidikan') }">{{ errors.first("profil-user-ortu.ayah_pendidikan") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-3">
                                  <b-form-group id="ayah_hp" label="No. Handphone">
                                    <b-form-input
                                      id="input-ayah_hp"
                                      class="form-user-ortu"
                                      name="ayah_hp"
                                      v-model="user_ortu_form.ayah_hp"
                                      type="text"
                                      placeholder="No. Handphone"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ayah_hp') }">{{ errors.first("profil-user-ortu.ayah_hp") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="ayah_pekerjaan" label="Pekerjaan">
                                    <b-form-input
                                      id="input-ayah_pekerjaan"
                                      class="form-user-ortu"
                                      name="ayah_pekerjaan"
                                      v-model="user_ortu_form.ayah_pekerjaan"
                                      type="text"
                                      placeholder="Pekerjaan"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ayah_pekerjaan') }">{{ errors.first("profil-user-ortu.ayah_pekerjaan") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                            </fieldset>
                            <hr />
                            <fieldset>
                              <legend>Ibu</legend>
                              <div class="row">
                                <div class="col-xl-6">
                                  <b-form-group id="nik_ibu" label="NIK">
                                    <b-form-input id="input-nik_ibu" class="form-user-ortu" name="nik_ibu" v-model="user_ortu_form.nik_ibu" type="text" placeholder="NIK" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.nik_ibu') }">{{ errors.first("profil-user-ortu.nik_ibu") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="ibu_nama" label="Nama">
                                    <b-form-input id="input-ibu_nama" class="form-user-ortu" name="ibu_nama" v-model="user_ortu_form.ibu_nama" type="text" placeholder="Nama" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ibu_nama') }">{{ errors.first("profil-user-ortu.ibu_nama") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-12">
                                  <b-form-group id="ibu_alamat" label="Alamat">
                                    <b-form-input
                                      id="input-ibu_alamat"
                                      class="form-user-ortu"
                                      name="ibu_alamat"
                                      v-model="user_ortu_form.ibu_alamat"
                                      type="text"
                                      placeholder="Alamat"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ibu_alamat') }">{{ errors.first("profil-user-ortu.ibu_alamat") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-3">
                                  <b-form-group id="ibu_pendidikan" label="Pendidikan">
                                    <b-form-input
                                      id="input-ibu_pendidikan"
                                      class="form-user-ortu"
                                      name="ibu_pendidikan"
                                      v-model="user_ortu_form.ibu_pendidikan"
                                      type="text"
                                      placeholder="Pendidikan"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ibu_pendidikan') }">{{ errors.first("profil-user-ortu.ibu_pendidikan") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-3">
                                  <b-form-group id="ibu_hp" label="No. Handphone">
                                    <b-form-input id="input-ibu_hp" class="form-user-ortu" name="ibu_hp" v-model="user_ortu_form.ibu_hp" type="text" placeholder="No. Handphone" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ibu_hp') }">{{ errors.first("profil-user-ortu.ibu_hp") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="ibu_pekerjaan" label="Pekerjaan">
                                    <b-form-input
                                      id="input-ibu_pekerjaan"
                                      class="form-user-ortu"
                                      name="ibu_pekerjaan"
                                      v-model="user_ortu_form.ibu_pekerjaan"
                                      type="text"
                                      placeholder="Pekerjaan"
                                      v-validate="'required'"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.ibu_pekerjaan') }">{{ errors.first("profil-user-ortu.ibu_pekerjaan") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                            </fieldset>
                            <hr />
                            <fieldset>
                              <legend>Wali</legend>
                              <div class="row">
                                <div class="col-xl-6">
                                  <b-form-group id="wali_nama" label="Nama">
                                    <b-form-input id="input-wali_nama" class="form-user-ortu" name="wali_nama" v-model="user_ortu_form.wali_nama" type="text" placeholder="Nama" v-validate="''" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_nama') }">{{ errors.first("profil-user-ortu.wali_nama") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-3">
                                  <b-form-group id="wali_hp" label="No. Handphone">
                                    <b-form-input id="input-wali_hp" class="form-user-ortu" name="wali_hp" v-model="user_ortu_form.wali_hp" type="text" placeholder="No. Handphone" v-validate="''" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_hp') }">{{ errors.first("profil-user-ortu.wali_hp") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-3">
                                  <b-form-group id="wali_tlp" label="No. Telepon">
                                    <b-form-input id="input-wali_tlp" class="form-user-ortu" name="wali_tlp" v-model="user_ortu_form.wali_tlp" type="text" placeholder="No. Telepon" v-validate="''" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_tlp') }">{{ errors.first("profil-user-ortu.wali_tlp") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-12">
                                  <b-form-group id="wali_alamat" label="Alamat">
                                    <b-form-input id="input-wali_alamat" class="form-user-ortu" name="wali_alamat" v-model="user_ortu_form.wali_alamat" type="text" placeholder="Alamat" v-validate="''" trim autocomplete="off"></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_alamat') }">{{ errors.first("profil-user-ortu.wali_alamat") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-6">
                                  <b-form-group id="wali_pendidikan" label="Pendidikan">
                                    <b-form-input
                                      id="input-wali_pendidikan"
                                      class="form-user-ortu"
                                      name="wali_pendidikan"
                                      v-model="user_ortu_form.wali_pendidikan"
                                      type="text"
                                      placeholder="Pendidikan"
                                      v-validate="''"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_pendidikan') }">{{ errors.first("profil-user-ortu.wali_pendidikan") }}</span>
                                  </b-form-group>
                                </div>
                                <div class="col-xl-6">
                                  <b-form-group id="wali_pekerjaan" label="Pekerjaan">
                                    <b-form-input
                                      id="input-wali_pekerjaan"
                                      class="form-user-ortu"
                                      name="wali_pekerjaan"
                                      v-model="user_ortu_form.wali_pekerjaan"
                                      type="text"
                                      placeholder="Pekerjaan"
                                      v-validate="''"
                                      trim
                                      autocomplete="off"
                                    ></b-form-input>
                                    <span :class="{ 'error-validation': errors.first('profil-user-ortu.wali_pekerjaan') }">{{ errors.first("profil-user-ortu.wali_pekerjaan") }}</span>
                                  </b-form-group>
                                </div>
                              </div>
                            </fieldset>
                            <hr />
                            <div class="profil-footer d-flex justify-content-end">
                              <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                              <b-button v-if="!showLoader" variant="primary" size="md" @click="saveUserOrtu">SIMPAN</b-button>
                            </div>
                          </b-form>
                        </b-card-text>
                      </b-tab>
                      <!-- <b-tab title="Masuk PKBM Ini" :title-item-class="'tab-title'">
                        <b-card-text>
                          <b-form data-vv-scope="profil-user-ijazah">
                            <div class="row">
                              <div class="col-xl-8">
                                <b-form-group id="jenis" label="Jenis">
                                  <b-form-input id="input-jenis" class="form-user-ijazah" name="jenis" v-model="user_ijazah_form.jenis" type="text" placeholder="Jenis" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-ijazah.jenis') }">{{ errors.first("profil-user-ijazah.jenis") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-2">
                                <b-form-group id="tahun" label="Tahun">
                                  <b-form-input id="input-tahun" class="form-user-ijazah" name="tahun" v-model="user_ijazah_form.tahun" type="number" placeholder="Tahun" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-ijazah.tahun') }">{{ errors.first("profil-user-ijazah.tahun") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-6">
                                <b-form-group id="tanggal_ijazah" label="Tanggal Ijazah (Format : tahun-bulan-hari)">
                                  <b-input-group class="mb-2">
                                    <b-form-input id="input-tanggal_ijazah" v-model="user_ijazah_form.tanggal_ijazah" type="text" placeholder="contoh: 2023-12-23" v-validate="'required'" autocomplete="off"></b-form-input>
                                    <b-input-group-append>
                                      <b-form-datepicker v-model="user_ijazah_form.tanggal_ijazah" button-only right locale="en-US" name="tanggal_ijazah" aria-controls="example-input"></b-form-datepicker>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <span :class="{ 'error-validation': errors.first('profil-form.tanggal_ijazah') }">{{ errors.first("profil-form.tanggal_ijazah") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-6">
                                <b-form-group id="nomor" label="Nomor">
                                  <b-form-input id="input-nomor" class="form-user-ijazah" name="nomor" v-model="user_ijazah_form.nomor" type="text" placeholder="Nomor" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-ijazah.nomor') }">{{ errors.first("profil-user-ijazah.nomor") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <hr />
                            <div class="profil-footer d-flex justify-content-end">
                              <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                              <b-button v-if="!showLoader" variant="primary" size="md" @click="saveUserIjazah">SIMPAN</b-button>
                            </div>
                          </b-form>
                        </b-card-text>
                      </b-tab> -->
                      <b-tab title="Masuk PKBM Ini" :title-item-class="'tab-title'">
                        <b-card-text>
                          <b-form data-vv-scope="profil-user-pindahan">
                            <div class="row">
                              <div class="col-xl-3">
                                <b-form-group id="opsiPindah" label="Opsi Pindahan">
                                  <b-form-select v-model="user_pindahan_form.opsiPindah" name="opsiPindah" data-vv-as="Opsi" :options="opsiPindahan" v-validate="'required'"> </b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.opsiPindah') }">{{ errors.first("profil-user-pindahan.opsiPindah") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-5">
                                <b-form-group id="sekolah_asal" label="Sekolah Asal">
                                  <b-form-input
                                    id="input-sekolah_asal"
                                    class="form-user-pindahan"
                                    name="sekolah_asal"
                                    v-model="user_pindahan_form.sekolah_asal"
                                    type="text"
                                    placeholder="Sekolah Asal"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.sekolah_asal') }">{{ errors.first("profil-user-pindahan.sekolah_asal") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-4" v-if="user_pindahan_form.opsiPindah === 'pindahan'">
                                <b-form-group id="nomor_surat_pindah" label="Nomor Surat Pindah">
                                  <b-form-input
                                    id="input-nomor_surat_pindah"
                                    class="form-user-pindahan"
                                    name="nomor_surat_pindah"
                                    v-model="user_pindahan_form.nomor_surat_pindah"
                                    type="text"
                                    placeholder="Nomor Surat Pindah"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.nomor_surat_pindah') }">{{ errors.first("profil-user-pindahan.nomor_surat_pindah") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-4">
                                <b-form-group id="npsn" label="Nomor Induk Sekolah Asal / NPSN">
                                  <b-form-input
                                    id="input-npsn"
                                    class="form-user-pindahan"
                                    name="npsn"
                                    v-model="user_pindahan_form.npsn"
                                    type="text"
                                    placeholder="Nomor Induk Sekolah Asal / NPSN"
                                    v-validate="'required'"
                                    trim
                                    autocomplete="off"
                                  ></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.npsn') }">{{ errors.first("profil-user-pindahan.npsn") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-4">
                                <b-form-group id="ijazah_yang_dimiliki" label="Ijazah Yang Dimiliki">
                                  <b-form-select v-model="user_pindahan_form.ijazah_yang_dimiliki" name="ijazah_yang_dimiliki" data-vv-as="Ijazah Yang Dimiliki" :options="opsiIjazah" v-validate="'required'"> </b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.ijazah_yang_dimiliki') }">{{ errors.first("profil-user-pindahan.ijazah_yang_dimiliki") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-4">
                                <b-form-group id="ijazah_terbit" label="Diterbitkan Pada Tanggal">
                                  <b-input-group class="mb-2">
                                    <b-form-input id="input-ijazah_terbit" v-model="user_pindahan_form.ijazah_terbit" type="text" placeholder="contoh: 2023-12-23" v-validate="'required'" autocomplete="off"></b-form-input>
                                    <b-input-group-append>
                                      <b-form-datepicker v-model="user_pindahan_form.ijazah_terbit" button-only right locale="en-US" name="ijazah_terbit" aria-controls="example-input"></b-form-datepicker>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.ijazah_terbit') }">{{ errors.first("profil-user-pindahan.ijazah_terbit") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-4">
                                <b-form-group id="tanggal_diterima" label="Diterima di PKBM Tanggal">
                                  <b-input-group class="mb-2">
                                    <b-form-input id="input-tanggal_diterima" v-model="user_diterima_form.tanggal" type="text" placeholder="contoh: 2023-12-23" name="tanggal_diterima" v-validate="'required'" autocomplete="off"></b-form-input>
                                    <b-input-group-append>
                                      <b-form-datepicker v-model="user_diterima_form.tanggal" button-only right locale="en-US" aria-controls="example-input"></b-form-datepicker>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.tanggal_diterima') }">{{ errors.first("profil-user-pindahan.tanggal_diterima") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-4">
                                <b-form-group id="kelas_diterima" label="Diterima di Kelas">
                                  <b-form-select
                                    id="input-kelas_diterima"
                                    class="form-user-pindahan"
                                    name="kelas_diterima"
                                    v-model="user_diterima_form.kelas"
                                    :options="opsiKelas"
                                    v-validate="'required'"
                                  ></b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.kelas_diterima') }">{{ errors.first("profil-user-pindahan.kelas_diterima") }}</span>
                                </b-form-group>
                              </div>
                              <div class="col-xl-4">
                                <b-form-group id="program_setara" label="Program Setara">
                                  <b-form-select
                                    id="input-program_setara"
                                    class="form-user-pindahan"
                                    name="program_setara"
                                    v-model="user_diterima_form.tingkatan"
                                    :options="opsiProgramSetara"
                                    data-vv-as="Program Setara"
                                    v-validate="'required'"
                                  ></b-form-select>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.program_setara') }">{{ errors.first("profil-user-pindahan.program_setara") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xl-12">
                                <b-form-group id="alasan" label="Alasan">
                                  <b-form-input id="input-alasan" class="form-user-pindahan" name="alasan" v-model="user_pindahan_form.alasan" type="text" placeholder="Alasan" v-validate="'required'" trim autocomplete="off"></b-form-input>
                                  <span :class="{ 'error-validation': errors.first('profil-user-pindahan.alasan') }">{{ errors.first("profil-user-pindahan.alasan") }}</span>
                                </b-form-group>
                              </div>
                            </div>
                            <hr />
                            <div class="profil-footer d-flex justify-content-end">
                              <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                              <b-button v-if="!showLoader" variant="primary" size="md" @click="saveUserPindahan">SIMPAN</b-button>
                            </div>
                          </b-form>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab title="Sosial Media" :title-item-class="'tab-title'">
                <b-card-text>
                  <b-form data-vv-scope="profil-sosial-media">
                    <b-form-group id="website" label="Website">
                      <b-form-input id="input-website" class="form-sosial-media" name="website" v-model="sosial_media_form.website" type="text" placeholder="Link Website" v-validate="''" trim autocomplete="off"></b-form-input>
                      <span :class="{ 'error-validation': errors.first('profil-sosial-media.website') }">{{ errors.first("profil-sosial-media.website") }}</span>
                    </b-form-group>
                    <b-form-group id="facebook" label="Facebook">
                      <b-form-input id="input-facebook" class="form-sosial-media" name="facebook" v-model="sosial_media_form.facebook" type="text" placeholder="Link Facebook" v-validate="''" trim autocomplete="off"></b-form-input>
                      <span :class="{ 'error-validation': errors.first('profil-sosial-media.facebook') }">{{ errors.first("profil-sosial-media.facebook") }}</span>
                    </b-form-group>
                    <b-form-group id="linkedin" label="Linkedin">
                      <b-form-input id="input-linkedin" class="form-sosial-media" name="linkedin" v-model="sosial_media_form.linkedin" type="text" placeholder="Link Linkedin" v-validate="''" trim autocomplete="off"></b-form-input>
                      <span :class="{ 'error-validation': errors.first('profil-sosial-media.linkedin') }">{{ errors.first("profil-sosial-media.linkedin") }}</span>
                    </b-form-group>
                    <b-form-group id="twitter" label="Twitter">
                      <b-form-input id="input-twitter" class="form-sosial-media" name="twitter" v-model="sosial_media_form.twitter" type="text" placeholder="Link Twitter" v-validate="''" trim autocomplete="off"></b-form-input>
                      <span :class="{ 'error-validation': errors.first('profil-sosial-media.twitter') }">{{ errors.first("profil-sosial-media.twitter") }}</span>
                    </b-form-group>
                    <hr />
                    <div class="profil-footer d-flex justify-content-end">
                      <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                      <b-button v-if="!showLoader" variant="primary" size="md" @click="saveSosmed">SIMPAN</b-button>
                    </div>
                  </b-form>
                </b-card-text>
              </b-tab>
              <b-tab title="Kata Sandi" :title-item-class="'tab-title'">
                <b-card-text>
                  <b-form data-vv-scope="change-password-form">
                    <b-form-group id="old-password" label="Kata Sandi Lama">
                      <b-form-input
                        id="input-old-password"
                        name="old_password"
                        data-vv-as="Kata sandi lama"
                        v-model="password_form.old_password"
                        type="password"
                        placeholder="Kata Sandi Lama"
                        v-validate="'required'"
                        trim
                        autocomplete="off"
                      ></b-form-input>
                      <span :class="{ 'error-validation': errors.first('change-password-form.old_password') }">{{ errors.first("change-password-form.old_password") }}</span>
                    </b-form-group>
                    <b-form-group id="new-password" label="Kata Sandi Baru">
                      <b-form-input
                        id="input-new-password"
                        ref="new_password"
                        name="new_password"
                        data-vv-as="Kata sandi baru"
                        v-model="password_form.new_password"
                        type="password"
                        placeholder="Kata Sandi Baru"
                        v-validate="'required'"
                        trim
                        autocomplete="off"
                      ></b-form-input>
                      <span :class="{ 'error-validation': errors.first('change-password-form.new_password') }">{{ errors.first("change-password-form.new_password") }}</span>
                    </b-form-group>
                    <b-form-group id="new-confirm-password" label="Ulangi Kata Sandi Baru">
                      <b-form-input
                        id="input-new-confirm-confirm-password"
                        name="new_password_confirmation"
                        data-vv-as="Konfirmasi kata sandi baru"
                        v-model="password_form.new_password_confirmation"
                        type="password"
                        placeholder="Ulangi Kata Sandi Baru"
                        v-validate="'required|confirmed:new_password'"
                        trim
                        autocomplete="off"
                      ></b-form-input>
                      <span :class="{ 'error-validation': errors.first('change-password-form.new_password_confirmation') }">{{ errors.first("change-password-form.new_password_confirmation") }}</span>
                    </b-form-group>
                    <hr />
                    <div class="profil-footer d-flex justify-content-end">
                      <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                      <b-button v-if="!showLoader" variant="primary" size="md" @click="changePassword">SIMPAN</b-button>
                    </div>
                  </b-form>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
export default {
  components: {
    SquareLoader,
  },
  data() {
    return {
      showLoader: false,
      showFotoUploadLoader: false,
      sosial_media_form: {
        website: null,
        facebook: null,
        linkedin: null,
        twitter: null,
      },
      foto_profile: null,
      profil_form: {
        full_name: null,
        old_email: null,
        email: null,
        nik_siswa: null,
        pekerjaan_siswa: null,
        gender: null,
        // province: null,
        // district: null,
        place_of_birth: null,
        date_of_birth: null,
        nis_nas: null,
        no_induk: null,
        // parent_name: null,
        // ibu_nama: null,
        // address: null,
        no_hp: null,
        tinggal_bersama: null,
        agama: null,
        anak_ke: null,
        saudara_kandung: 0,
        saudara_tiri: 0,
        status_keluarga: null,
        bahasa_sehari: null,
        kewarganegaraan: null,
      },
      password_form: {
        old_password: null,
        new_password: null,
        new_password_confirmation: null,
      },
      user_address_form: {
        jalan: null,
        rt: null,
        rw: null,
        dusun: null,
        desa: null,
        kecamatan: null,
        kabupaten: null,
        provinsi: null,
        kode_pos: null,
      },
      user_ortu_form: {
        no_kk: null,
        nama_kk: null,
        parent_name: null,
        ayah_alamat: null,
        ayah_hp: null,
        ayah_pendidikan: null,
        ayah_pekerjaan: null,
        ibu_nama: null,
        ibu_alamat: null,
        ibu_hp: null,
        ibu_pendidikan: null,
        ibu_pekerjaan: null,
        wali_nama: null,
        wali_alamat: null,
        wali_hp: null,
        wali_tlp: null,
        wali_pendidikan: null,
        wali_pekerjaan: null,
      },
      user_ijazah_form: {
        jenis: null,
        tahun: null,
        tanggal_ijazah: null,
        nomor: null,
      },
      user_pindahan_form: {
        sekolah_asal: null,
        alasan: null,
        opsiPindah: null,
        nomor_surat_pindah: null,
        tanggal: null,
        npsn: null,
        ijazah_terbit: null,
        ijazah_yang_dimiliki: null,
      },
      user_diterima_form: {
        tanggal: null,
        kelas: null,
        tingkatan: null,
      },
      gender: [
        { value: null, text: "Silakan Pilih Jenis Kelamin", disabled: true },
        { value: "L", text: "Laki-Laki" },
        { value: "P", text: "Perempuan" },
      ],
      opsiPindahan: [
        { value: null, text: "Silakan Pilih Salah satu", disabled: true },
        { value: "sekolah", text: "Dari Sekolah" },
        { value: "pindahan", text: "Pindahan" },
      ],
      opsiIjazah: [
        { value: null, text: "Silakan Pilih Salah satu", disabled: true },
        { value: "sd", text: "SD/Sederajat" },
        { value: "smp", text: "SMP/Sederajat" },
        { value: "sma", text: "SMA/Sederajat" },
      ],
      opsiKelas: [
        { value: null, text: "Silakan Pilih Kelas", disabled: true },
        { value: "12", text: "12" },
        { value: "11", text: "11" },
        { value: "10", text: "10" },
        { value: "9", text: "9" },
        { value: "8", text: "8" },
        { value: "7", text: "7" },
        { value: "6", text: "6" },
        { value: "5", text: "5" },
        { value: "4", text: "4" },
        { value: "3", text: "3" },
        { value: "2", text: "2" },
        { value: "1", text: "1" },
      ],
      opsiProgramSetara: [
        { value: null, text: "Silakan Pilih Program Setara", disabled: true },
        { value: "Paket A", text: "Paket A" },
        { value: "Paket B", text: "Paket B" },
        { value: "Paket C", text: "Paket C" },
      ],
      agamaList: [
        { value: null, text: "Silakan Pilih Agama", disabled: true },
        { value: "Islam", text: "Islam" },
        { value: "Kristen", text: "Kristen" },
        { value: "Katolik", text: "Katolik" },
        { value: "Hindu", text: "Hindu" },
        { value: "Budha", text: "Budha" },
        { value: "Konghucu", text: "Konghucu" },
      ],
      anakKeList: [
        { value: null, text: "Silakan Pilih", disabled: true },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      provinces: "getProvinces",
      districts: "getDistricts",
    }),
  },
  watch: {
    user: function (newVal) {
      this.profil_form.full_name = newVal.full_name;
      this.profil_form.old_email = newVal.email;
      this.profil_form.nik_siswa = newVal.nik_siswa;
      this.profil_form.pekerjaan_siswa = newVal.pekerjaan_siswa;
      this.profil_form.email = newVal.email;
      this.profil_form.gender = newVal.gender;
      // this.profil_form.province = newVal.province
      // this.profil_form.district = newVal.district
      this.profil_form.date_of_birth = newVal.date_of_birth;
      this.profil_form.place_of_birth = newVal.place_of_birth;
      this.profil_form.no_induk = newVal.no_induk;
      // this.profil_form.parent_name = newVal.parent_name
      // this.profil_form.ibu_nama = newVal.ibu_nama
      this.profil_form.nis_nas = newVal.nis_nas;
      this.profil_form.no_hp = newVal.no_hp;
      this.profil_form.tinggal_bersama = newVal.tinggal_bersama;
      this.profil_form.agama = newVal.agama;
      this.profil_form.anak_ke = newVal.anak_ke;
      this.profil_form.saudara_kandung = newVal.saudara_kandung;
      this.profil_form.saudara_tiri = newVal.saudara_tiri;
      this.profil_form.status_keluarga = newVal.status_keluarga;
      this.profil_form.bahasa_sehari = newVal.bahasa_sehari;
      this.profil_form.kewarganegaraan = newVal.kewarganegaraan;
      // this.profil_form.address = newVal.address
      this.sosial_media_form.website = newVal.website;
      this.sosial_media_form.facebook = newVal.facebook;
      this.sosial_media_form.linkedin = newVal.linkedin;
      this.sosial_media_form.twitter = newVal.twitter;

      this.user_address_form.jalan = newVal.jalan;
      this.user_address_form.rt = newVal.rt;
      this.user_address_form.rw = newVal.rw;
      this.user_address_form.dusun = newVal.dusun;
      this.user_address_form.desa = newVal.desa;
      this.user_address_form.kecamatan = newVal.kecamatan;
      this.user_address_form.kabupaten = newVal.kabupaten;
      this.user_address_form.provinsi = newVal.provinsi;
      this.user_address_form.kode_pos = newVal.kode_pos;

      this.user_ortu_form.parent_name = newVal.parent_name;
      this.user_ortu_form.no_kk = newVal.no_kk;
      this.user_ortu_form.nama_kk = newVal.nama_kk;
      this.user_ortu_form.ayah_alamat = newVal.ayah_alamat;
      this.user_ortu_form.ayah_hp = newVal.ayah_hp;
      this.user_ortu_form.ayah_pekerjaan = newVal.ayah_pekerjaan;
      this.user_ortu_form.ayah_pendidikan = newVal.ayah_pendidikan;
      this.user_ortu_form.ibu_alamat = newVal.ibu_alamat;
      this.user_ortu_form.ibu_hp = newVal.ibu_hp;
      this.user_ortu_form.ibu_nama = newVal.ibu_nama;
      this.user_ortu_form.ibu_pekerjaan = newVal.ibu_pekerjaan;
      this.user_ortu_form.ibu_pendidikan = newVal.ibu_pendidikan;
      this.user_ortu_form.wali_alamat = newVal.wali_alamat;
      this.user_ortu_form.wali_hp = newVal.wali_hp;
      this.user_ortu_form.wali_nama = newVal.wali_nama;
      this.user_ortu_form.wali_pekerjaan = newVal.wali_pekerjaan;
      this.user_ortu_form.wali_pendidikan = newVal.wali_pendidikan;
      this.user_ortu_form.wali_tlp = newVal.wali_tlp;

      this.user_ijazah_form.jenis = newVal.jenis;
      this.user_ijazah_form.tahun = newVal.tahun;
      this.user_ijazah_form.tanggal_ijazah = newVal.tanggal_ijazah;
      this.user_ijazah_form.nomor = newVal.nomor;

      this.user_pindahan_form.sekolah_asal = newVal.sekolah_asal;
      this.user_pindahan_form.opsiPindah = newVal.opsiPindah;
      this.user_pindahan_form.nomor_surat_pindah = newVal.nomor_surat_pindah;
      this.user_pindahan_form.tanggal = newVal.tanggal;
      this.user_pindahan_form.npsn = newVal.npsn;
      this.user_pindahan_form.ijazah_terbit = newVal.ijazah_terbit;
      this.user_pindahan_form.ijazah_yang_dimiliki = newVal.ijazah_yang_dimiliki;
      this.user_pindahan_form.alasan = newVal.alasan;

      this.user_diterima_form.tanggal = newVal.tanggal_diterima;
      this.user_diterima_form.kelas = newVal.kelas_diterima;
      this.user_diterima_form.tingkatan = newVal.tingkatan_diterima;

      this.$validator.reset();
    },
    "profil_form.province": {
      deep: true,
      async handler(newVal) {
        if (newVal) {
          await this.getDistricts(newVal);
          // this.profil_form.district = null
        }
      },
    },
  },
  methods: {
    async getUser() {
      await this.$store
        .dispatch("getUser")
        .then(() => {})
        .catch(() => {
          // this.$swal.fire('Perhatian !', err.response.data.message, 'error')
        });
    },
    async getProvinces() {
      await this.$store
        .dispatch("getProvinces")
        .then(() => {})
        .catch(() => {
          // this.$swal.fire('Perhatian !', err.response.data.message, 'error')
        });
    },
    async getDistricts(province) {
      await this.$store
        .dispatch("getDistricts", { code: province })
        .then(() => {})
        .catch(() => {
          // this.$swal.fire('Perhatian !', err.response.data.message, 'error')
        });
    },
    async changePassword() {
      let scope = "change-password-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.password_form;
          this.$store
            .dispatch("changePassword", form)
            .then((res) => {
              this.showLoader = false;
              this.password_form.old_password = null;
              this.password_form.new_password = null;
              this.password_form.new_password_confirmation = null;
              this.$validator.reset();
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveProfile() {
      let scope = "profil-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.profil_form;
          this.$store
            .dispatch("saveProfile", form)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveSosmed() {
      let scope = "profil-sosial-media";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.sosial_media_form;
          this.$store
            .dispatch("saveSosmed", form)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveUserAddress() {
      let scope = "profil-user-address";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.user_address_form;
          this.$store
            .dispatch("saveUserAddress", form)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveUserOrtu() {
      let scope = "profil-user-ortu";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.user_ortu_form;
          this.$store
            .dispatch("saveUserOrtu", form)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveUserIjazah() {
      let scope = "profil-user-ijazah";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.user_ijazah_form;
          this.$store
            .dispatch("saveUserIjazah", form)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveUserPindahan() {
      let scope = "profil-user-pindahan";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let form = this.user_pindahan_form;
          let diterimaForm = this.user_diterima_form;
          Promise.all([
            this.$store.dispatch("saveUserPindahan", form),
            this.$store.dispatch("saveUserDiterima", diterimaForm),
          ])
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res[0].data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveFotoProfile() {
      let scope = "foto-profile-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showFotoUploadLoader = true;
          let formData = new FormData();
          formData.append("image_path", this.foto_profile);
          this.$store
            .dispatch("saveFotoProfile", formData)
            .then((res) => {
              this.getUser();
              this.showFotoUploadLoader = false;
              this.foto_profile = null;
              this.$validator.reset();
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showFotoUploadLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveTtd() {
      let scope = "ttd-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showFotoUploadLoader = true;
          let formData = new FormData();
          formData.append("ttd", this.ttd);
          this.$store
            .dispatch("saveTtd", formData)
            .then((res) => {
              this.getUser();
              this.showFotoUploadLoader = false;
              this.ttd = null;
              this.$validator.reset();
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showFotoUploadLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Perhatian !", error.data.message, "error");
              }
            });
        }
      });
    },
  },
  async created() {
    await this.getUser();
    // await this.getProvinces()
  },
};
</script>
